import React, { Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MarketReports from './MarketReports';
import ResearchLibrary from './ResearchLibrary';
import Exports from './Exports';
import KpiForecasts from './KpiForecasts';
import PageHeader from '../components/PageHeader';
import DownloadReportModal from '../components/DownloadReportModal';

import { changePage } from '../actions';
import { baseURL } from '../configs';
import { currentPageSelector } from '../selectors';
import scrollPage from '../../../utils/scrollPage';

const PageContainer = () => {
  const dispatch = useDispatch();

  const currentPage = useSelector(currentPageSelector);

  const handlePageChange = useCallback((nextPage) => {
    dispatch(changePage(nextPage));
    window.history.replaceState(null, '', `${baseURL}#${nextPage}`);
    scrollPage();
  }, []);

  const ContentContainer = {
    'market-reports': <MarketReports />,
    'research-library': <ResearchLibrary />,
    exports: <Exports />,
    'kpi-forecasts': <KpiForecasts />,
  }[currentPage];

  return (
    <Fragment>
      <PageHeader
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
      {ContentContainer}

      <DownloadReportModal currentPage={currentPage} />
    </Fragment>
  );
};

export default PageContainer;
